import { getThe, select } from 'src/store/selectors/utils'

const getMortgageCoach = state => state.mortgageCoach
const selectFromMortgageCoach = select(getMortgageCoach)

export const selectClientHasTunedMortgageCoachValue = selectFromMortgageCoach(
  getThe('hasTunedMortgageCoachValue')
)
